// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogMovePlanTasks__Count[data-v-36b358ac] {\n  margin-bottom: 6px;\n}\n.DialogMovePlanTasks__From[data-v-36b358ac] {\n  margin-bottom: 14px;\n  font-size: 13px;\n  color: #6b7b8c;\n}\n.note[data-v-36b358ac] {\n  margin-top: 16px;\n  font-size: 13px;\n  color: #6b7b8c;\n}\n", ""]);
// Exports
module.exports = exports;
